export const FACEBOOK_LINK = "https://www.facebook.com/brightgrove";
export const INSTA_LINK = "https://www.instagram.com/brightgrove/";
export const TWITTER_LINK = "https://twitter.com/BrightgroveLtd";
export const YOUTUBE_LINK =
  "https://www.youtube.com/channel/UCVwNLlwOVW7WPVDf4W92u3A/featured";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/brightgrove/";
